import { combineReducers } from "redux";
import housingReducer from "./housingReducer";
import traitsReducer from "./traitsReducer";
import { errorReducer } from "./errorReducer";
import successReducer from "./successReducer";
import applicationsReducer from "./applicationsReducer";
import admissionsReducer from "./admissionsReducer";
import paymentsReducer from "./paymentsReducer";
import documentRequestReducer from "./documentRequestReducer";
import feesReducer from "./feesReducer";
import examinationsReducer from "./examinationsReducer";
import academicSessionsReducer from "./academicSessionsReducer";
import parentsReducer from "./parentsReducer";
import studentsReducer from "./studentsReducer";
import departmentReducer from "./departmentReducer";
import documentReducer from "./documentReducer";
import classesDivisionsReducer from "./classesDivisionsReducer";
import staffReducer from "./staffReducer";
import designationReducer from "./designationReducer";
import rolesPermissionsReducer from "./rolesPermissionsReducer";
import auditLogsReducer from "./auditLogsReducer";
import examinationCentersReducer from "./examinationCentersReducer";
import applicationResponsesReducer from "./applicationResponsesReducer";
import downloadablesReducer from "./downloadablesReducer";
import examSchedulesReducer from "./examSchedulesReducer";
import invoicesReducer from "./invoicesReducer";
import collegeAccountsReducer from "./collegeAccountsReducer";
import sundriesReducer from "./sundriesReducer";
import exeatsReducer from "./exeatsReducer";
import termsReducer from "./termsReducer";
import subjectsReducer from "./subjectsReducer";
import dashboardReducer from "./dashboardReducer";
import adminDashboardReducer from "./adminDashboardReducer";
import accountingDashboardReducer from "./accountingDashboardReducer";
import academicDashboardReducer from "./academicDashboardReducer";
import inventoryDashboardReducer from "./inventoryDashboardReducer";
import inventoryReducer from "./inventoryReducer";
import assessmentsReducer from "./assessmentsReducer";
import studentFeedbackReducer from "./studentFeedbackReducer";
import disciplinaryRecordsReducer from "./disciplinaryRecordsReducer";
import scholarshipsReducer from "./scholarshipsReducer";
import sickbayReducer from "./sickbayReducer";
import resultsReducer from "./resultsReducer";

const rootReducer = combineReducers({
    success: successReducer,
    errors: errorReducer,
    applications: applicationsReducer,
    admissions: admissionsReducer,
    payments: paymentsReducer,
    fees: feesReducer,
    documentRequests: documentRequestReducer,
    examinations: examinationsReducer,
    academicSessions: academicSessionsReducer,
    parents: parentsReducer,
    students: studentsReducer,
    departments: departmentReducer,
    documents: documentReducer,
    classes: classesDivisionsReducer,
    staff: staffReducer,
    designations: designationReducer,
    roles: rolesPermissionsReducer,
    auditLogs: auditLogsReducer,
    examinationCenters: examinationCentersReducer,
    applicationResponses: applicationResponsesReducer,
    downloadables: downloadablesReducer,
    examSchedules: examSchedulesReducer,
    invoices: invoicesReducer,
    accounts: collegeAccountsReducer,
    sundries: sundriesReducer,
    exeats: exeatsReducer,
    terms: termsReducer,
    subjects: subjectsReducer,
    dashboard: dashboardReducer,
    adminDashboard: adminDashboardReducer,
    accountingDashboard: accountingDashboardReducer,
    academicDashboard: academicDashboardReducer,
    inventoryDashboard: inventoryDashboardReducer,
    inventory: inventoryReducer,
    assessments: assessmentsReducer,
    feedback: studentFeedbackReducer,
    disciplinaryRecords: disciplinaryRecordsReducer,
    sickbay: sickbayReducer,
    scholarships: scholarshipsReducer,
    housing: housingReducer,
    traits: traitsReducer,
    results: resultsReducer,
});


export default rootReducer;
